import { useEffect, useState } from 'react'
import { Box, Button, Grid, Paper, TextField, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { getDevice, updateDevice } from '../../api/device'
import { Device } from '../../types/api'

export default function DeviceEditPage() {
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const [form, setForm] = useState<Partial<Device> | null>(null)

    // โหลดข้อมูลอุปกรณ์
    const load = async () => {
        if (!id) return
        const data = await getDevice(Number(id))
        setForm(data)
    }

    useEffect(() => {
        load()
    }, [id])

    const handleChange = (field: keyof Device, value: any) => {
        setForm((prev) => (prev ? { ...prev, [field]: value } : prev))
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!form || !id) return
        await updateDevice(Number(id), form)
        navigate('/devices')
    }

    if (!form) return <Typography>กำลังโหลด...</Typography>

    return (
        <Box>
            <Typography variant="h6" mb={2}>แก้ไขอุปกรณ์ GPS</Typography>
            <Paper sx={{ p: 3 }}>
                <Box component="form" onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <TextField
                                fullWidth
                                label="Box ID"
                                value={form.boxId || ''}
                                onChange={(e) => handleChange('boxId', e.target.value)}
                                required
                            />
                        </Grid>

                        <Grid size={6}>
                            <TextField
                                fullWidth
                                label="SIM Number"
                                value={form.simNumber || ''}
                                onChange={(e) => handleChange('simNumber', e.target.value)}
                            />
                        </Grid>

                        <Grid size={6}>
                            <TextField
                                fullWidth
                                label="Firmware"
                                value={form.firmware || ''}
                                onChange={(e) => handleChange('firmware', e.target.value)}
                            />
                        </Grid>

                        <Grid size={6}>
                            <TextField
                                fullWidth
                                label="SR"
                                value={form.sr || ''}
                                onChange={(e) => handleChange('sr', e.target.value)}
                            />
                        </Grid>

                        <Grid size={6}>
                            <TextField
                                fullWidth
                                label="SIM Lot"
                                value={form.simLot || ''}
                                onChange={(e) => handleChange('simLot', e.target.value)}
                            />
                        </Grid>

                        <Grid size={12} display="flex" justifyContent="flex-end">
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{ backgroundColor: '#FEDC00', color: '#000' }}
                            >
                                บันทึก
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{ ml: 2 }}
                                onClick={() => navigate('/devices')}
                            >
                                ยกเลิก
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Box>
    )
}
